import { option, string } from 'fp-ts';
import { Option } from 'fp-ts/Option';

import { LocalizedText } from '@mews/framework/localization';
import { Link } from '@optimus-web/core';

import { MarkdownLink } from './MarkdownLink';

interface LinkProps {
    markdown: Option<string>;
    textKey: Mews.TextKey;
    url: Option<string>;
}

export const TermsLink = ({ markdown, textKey, url }: LinkProps) => {
    if (option.isSome(markdown)) {
        return <MarkdownLink markdown={markdown.value} textKey={textKey} />;
    } else if (option.isSome(url) && !string.isEmpty(url.value)) {
        return (
            <Link href={url.value} target="_blank" rel="noopener noreferrer" inherit>
                <LocalizedText textKey={textKey} />
            </Link>
        );
    }

    return <LocalizedText textKey={textKey} />;
};
